import {AssemblyModel} from "./AssemblyModel";

export enum MonsterSlot {
    Head = "head",
    Body = "body",
    BackLegs = "blegs",
    FrontLegs = "flegs",
}

export const MonsterSlots = [
    MonsterSlot.Body,
    MonsterSlot.BackLegs,
    MonsterSlot.FrontLegs,
    MonsterSlot.Head,
];

export type MonsterModel = AssemblyModel<MonsterSlot>;